import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AccountSetupLoading from '../common/AccountSetupLoading';
import { useUser } from '../userContext';

const AccountSetup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading, userProfile, updateUserProfile } = useUser();
  const [isCompleting, setIsCompleting] = useState(false);
  const [error, setError] = useState(null);
  const isWaitingForProfile = loading || !user || !userProfile;
  const fromSignup = Boolean(location.state?.fromSignup);
  const skipIntro = fromSignup;

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/studio/login', { replace: true });
      return;
    }
    if (userProfile?.onboardingComplete === true) {
      navigate('/studio/new', { replace: true });
    }
  }, [loading, user, userProfile, navigate]);

  const handleComplete = async () => {
    if (isCompleting || !user || isWaitingForProfile) return;
    setIsCompleting(true);
    setError(null);
    try {
      await updateUserProfile({ onboardingComplete: true });
      navigate('/studio/new', { replace: true });
    } catch (err) {
      console.error('Failed to complete onboarding:', err);
      setError(err);
      setIsCompleting(false);
    }
  };

  if (error) {
    return (
      <div
        className="admin-theme fixed inset-0 flex flex-col items-center justify-center z-50"
        style={{ fontFamily: '"Inter", sans-serif', backgroundColor: 'var(--admin-bg-primary)' }}
      >
        <div className="gch-bg-card rounded-2xl shadow-xl border border-[var(--admin-border)] p-8 max-w-sm w-full mx-4 text-center">
          <p className="text-sm font-semibold gch-text-primary mb-2">Something went wrong</p>
          <p className="text-xs gch-text-secondary mb-5">We couldn't finish setting up your account. Please try again.</p>
          <button
            onClick={handleComplete}
            className="btn-admin-primary btn-admin-md w-full"
          >
            Try again
          </button>
          <button
            onClick={() => navigate('/studio/new', { replace: true })}
            className="mt-3 text-xs font-medium gch-text-muted hover:gch-text-primary transition-colors w-full py-2"
          >
            Skip for now
          </button>
        </div>
      </div>
    );
  }

  return (
    <AccountSetupLoading
      onComplete={isWaitingForProfile ? undefined : handleComplete}
      waiting={false}
      holdUntilReady={isCompleting || isWaitingForProfile}
      skipIntro={skipIntro}
      firstName={userProfile?.firstName}
    />
  );
};

export default AccountSetup;
